import React, { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";

const ConfirmButton = ({ onComplete, text, direction }) => { // Recibimos la función onComplete como prop
    const { t } = useTranslation();
    const [progress, setProgress] = useState(0);
    const [isPressing, setIsPressing] = useState(false);
    const timerRef = useRef(null);

    // Iniciar la barra de progreso cuando el mouse se presiona
    const startTimer = () => {
        if (!isPressing) {
            setIsPressing(true);
            setProgress(0);
            timerRef.current = setInterval(() => {
                setProgress((prev) => {
                    if (prev >= 100) {
                        clearInterval(timerRef.current);
                        onComplete(); // Llamamos a la función onComplete cuando la transacción se completa
                        return 100;
                    }
                    return prev + 1;
                });
            }, 30); // Incrementa 1% cada 30ms (3 segundos = 100%)
        }
    };

    // Cancelar la acción si el mouse es soltado o si sale del área del botón
    const cancelTimer = () => {
        clearInterval(timerRef.current);
        setProgress(0);
        setIsPressing(false);
    };

    return (
        <div className="relative w-full flex justify-center items-center">
            <button className="shim-packages p-4 rounded-lg flex flex-justify items-center gap-2 opacity-80 hover:opacity-100 w-1/2 relative"
                onMouseDown={startTimer}  // Inicia cuando se presiona
                onMouseUp={cancelTimer}   // Detiene cuando se suelta
                onMouseLeave={cancelTimer} // Detiene si el mouse sale del área del botón
                disabled={isPressing && progress < 100} // Deshabilitar el botón mientras se presiona
            >
                {direction === "left" ?
                    <>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                        </svg>
                        <p>{text || "..."}</p>
                    </>
                    :
                    <>
                        <p>{text || "..."}</p>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                        </svg>
                    </>}

                <span
                    className="absolute bottom-0 left-0 h-1 bg-green-500 rounded-full transition-all w-1/2"
                    style={{ width: `${progress}%` }}
                />
            </button>
        </div >
    );
};

export default ConfirmButton;
